import {logicalTypes} from './../consts';

const binaryOperators = {
    and: {
        value: 'and',
        displayLabelKey: 'filter.and.label'
    },
    or: {
        value: 'or',
        displayLabelKey: 'filter.or.label'
    }
};

const numericOperators = {
    eq: {
        value: 'eq',
        symbolDisplayKey: 'filter.eq.symbol',
        displayLabelKey: 'filter.eq.label'
    },
    neq: {
        value: 'neq',
        symbolDisplayKey: 'filter.neq.symbol',
        displayLabelKey: 'filter.neq.label'
    },
    gt: {
        value: 'gt',
        symbolDisplayKey: 'filter.gt.symbol',
        displayLabelKey: 'filter.gt.label'
    },
    ge: {
        value: 'ge',
        symbolDisplayKey: 'filter.ge.symbol',
        displayLabelKey: 'filter.ge.label'
    },
    lt: {
        value: 'lt',
        symbolDisplayKey: 'filter.lt.symbol',
        displayLabelKey: 'filter.lt.label',
    },
    le: {
        value: 'le',
        symbolDisplayKey: 'filter.le.symbol',
        displayLabelKey: 'filter.le.label'
    },
    bt: {
        value: 'bt',
        symbolDisplayKey: 'filter.bt.symbol',
        displayLabelKey: 'filter.bt.label'
    }
};

const logicalOperators = {
    ...numericOperators,
    in: {
        value: 'in',
        displayLabelKey: 'filter.in.label'
    },
    nin: {
        value: 'nin',
        displayLabelKey: 'filter.nin.label'
    },
    co: {
        value: 'co',
        displayLabelKey: 'filter.co.label'
    }
};

const existentialOperators = {
    isEmpty: {
        value: 'isEmpty',
        symbolDisplayKey: 'filter.isEmpty.symbol', //(Empty)
        displayLabelKey: 'filter.isEmpty.label'
    },
    isNotEmpty: {
        value: 'isNotEmpty',
        symbolDisplayKey: 'filter.isNotEmpty.symbol', //(Not Empty)
        displayLabelKey: 'filter.isNotEmpty.label'
    }
};

const operatorsByLogicalType = {
    [logicalTypes.TEXT]: [logicalOperators.co],
    [logicalTypes.NUMBER]: [
        logicalOperators.eq,
        logicalOperators.neq,
        logicalOperators.gt,
        logicalOperators.ge,
        logicalOperators.lt,
        logicalOperators.le,
        logicalOperators.bt
    ],
    [logicalTypes.ENUM]: [logicalOperators.in],
    [logicalTypes.ENTITY]: [logicalOperators.in]
};

const isPlainObject = (x) => {
    let toString = Object.prototype.toString, prototype;
    return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};

/* exposed functions === ↓*/

const numberReg = /-?(\d+|\d+\.\d+|\.\d+)([eE][-+]?\d+)?/;

const getBinaryOperators = () => (JSON.parse(JSON.stringify(binaryOperators)));

const getNumericOperators = () => (JSON.parse(JSON.stringify(numericOperators)));

const getLogicalOperators = () => (JSON.parse(JSON.stringify(logicalOperators)));

const getExistentialOperators = () => (JSON.parse(JSON.stringify(existentialOperators)));

const getSupportedLogicalTypes = () => (Object.keys(operatorsByLogicalType));

const isValidFilterExpression = (filter) => {
    return isPlainObject(filter) && (() => {
        if (Object.keys(binaryOperators).includes(filter.operator)) {
            return Array.isArray(filter.value) && filter.value.every(isValidFilterExpression);
        } else if (Object.keys(logicalOperators).includes(filter.operator)) {
            return ('value' in filter) && filter.property;
        } else if (Object.keys(existentialOperators).includes(filter.operator)) {
            return filter.property;
        } else {
            return false;
        }
    })();
};

const getFilterBeforeStore = (filter, metadata) => {
    let filterCopy;
    if (isValidFilterExpression(filter)) {
        if (!Object.keys(binaryOperators).includes(filter.operator)) {
            if (existentialOperators[filter.operator]) {
                filterCopy = {property: filter.property, operator: filter.operator};
            } else if (logicalOperators[filter.operator]) {
                let values = [];
                if (metadata.type === logicalTypes.NUMBER || metadata.type === logicalTypes.ENTITY || metadata.type === logicalTypes.ENUM) {
                    if (typeof(filter.value) === 'number') {
                        values = [String(filter.value)];
                    } else if (typeof(filter.value) === 'string') {
                        values = filter.value.split(',').map(v => v.trim());
                    } else if (Array.isArray(filter.value)) {
                        values = filter.value.map(v => String(v).trim());
                    }
                } else if (metadata.type === logicalTypes.TEXT) {
                    values = [filter.value.trim()];
                }
                if (metadata.type === logicalTypes.NUMBER) {
                    if (filter.operator === logicalOperators.in.value) {
                        values.length >= 1 && values.some(v => v.match(numberReg)) && (() => {
                            filterCopy = {...filter, value: `${values.filter(v => v.match(numberReg))}`}
                        })();
                    } else if (filter.operator === logicalOperators.bt.value) {
                        values.length === 2 && values.every(v => v.match(numberReg)) && (() => {
                            filterCopy = {...filter, value: `${values.filter(v => v.match(numberReg))}`}
                        })();
                    } else {
                        values.length === 1 && values.every(v => v.match(numberReg)) && (() => {
                            filterCopy = {...filter, value: `${values[0]}`}
                        })();
                    }
                } else if (metadata.type === logicalTypes.TEXT) {
                    values.length === 1 && values[0].length && (() => {
                        filterCopy = {...filter, value: `${values}`}
                    })();
                } else if (metadata.type === logicalTypes.ENUM) {
                    values.length >= 1 && values.every(v => (((metadata.presenter || {}).controlOptions || {}).options || []).map(option => option.value).includes(v)) && (() => {
                        filterCopy = {...filter, value: `${values}`}
                    })();
                } else if (metadata.type === logicalTypes.ENTITY) {
                    values.length >= 1 && values.some(v => v.length) && (() => {
                        filterCopy = {...filter, value: `${values.filter(v => v.length)}`}
                    })();
                }
            }
        }
    }
    return filterCopy;
};

const getOperatorOptionsByMetadata = (metadata) => {
    let options = [];
    if (isPlainObject(metadata)) {
        metadata.name === 'id' && options.push(logicalOperators.in);
        options.push(...(operatorsByLogicalType[metadata.type] || []));
        !metadata.required && !metadata.isSystem && options.push(...Object.values(existentialOperators));
    }
    return options;
};

const getAvailableGridFilters = (filter) => {
    let filters, validOperators = Object.keys(logicalOperators).concat(Object.keys(existentialOperators));
    if (isValidFilterExpression(filter)) {
        if (filter.operator === binaryOperators.and.value) {
            filters = filter.value.reduce((p, n) => {
                isValidFilterExpression(n) && validOperators.includes(n.operator) && p.push(JSON.parse(JSON.stringify(n)));
                return p;
            }, []);
        } else if (validOperators.includes(filter.operator)) {
            filters = [JSON.parse(JSON.stringify(filter))];
        }
    }
    return filters || [];
};

const combineFilters = (...filters) => {
    let validFilters = filters.filter(isValidFilterExpression);
    return validFilters.length > 1 ? {
        operator: binaryOperators.and.value,
        value: [...validFilters]
    } : validFilters[0] || {};
};

const toQueryString = (filter) => {
    let filterString;
    if (isValidFilterExpression(filter)) {
        if (Object.keys(binaryOperators).includes(filter.operator)) {
            filterString = '(' + filter.value.reduce((p, n) => {
                p.push(toQueryString(n));
                return p;
            }, []).join(`+${filter.operator}+`) + ')';
        } else if (Object.keys(logicalOperators).includes(filter.operator)) {
            let wrappedValue = logicalOperators.co.value === filter.operator ? `%${filter.value}%` : filter.value;
            filterString = `(${filter.property}+${filter.operator}+"${wrappedValue}")`;
        } else if (Object.keys(existentialOperators).includes(filter.operator)) {
            filterString = `(${filter.property}+${filter.operator === existentialOperators.isEmpty.value ? 'eq' : 'neq'}+"null")`;
        }
    }
    return filterString || '';
};

/* exposed functions === ↑*/

export {
    toQueryString as default,
    numberReg,
    getBinaryOperators,
    getNumericOperators,
    getLogicalOperators,
    getExistentialOperators,
    getSupportedLogicalTypes,
    isValidFilterExpression,
    getFilterBeforeStore,
    getOperatorOptionsByMetadata,
    getAvailableGridFilters,
    combineFilters,
    toQueryString
};


// WEBPACK FOOTER //
// ./src/app/utils/filterExpression.js